import React from 'react';

const STORAGE_KEY = 'izya_admin_theme';
const ThemeContext = React.createContext({
  theme: 'system',
  resolved: 'light',
  setTheme: () => {}
});

const getSystemTheme = () =>
  window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';

const applyTheme = (resolved) => {
  const root = document.documentElement;
  root.classList.toggle('dark', resolved === 'dark');
  root.style.colorScheme = resolved;
};

export const ThemeProvider = ({ children }) => {
  const [theme, setThemeState] = React.useState(
    () => localStorage.getItem(STORAGE_KEY) || 'system'
  );
  const [resolved, setResolved] = React.useState(() =>
    theme === 'system' ? getSystemTheme() : theme
  );

  const setTheme = (next) => {
    setThemeState(next);
    localStorage.setItem(STORAGE_KEY, next);
  };

  React.useEffect(() => {
    const next = theme === 'system' ? getSystemTheme() : theme;
    setResolved(next);
    applyTheme(next);
  }, [theme]);

  React.useEffect(() => {
    const media = window.matchMedia('(prefers-color-scheme: dark)');
    const onChange = () => {
      if (theme === 'system') {
        const next = getSystemTheme();
        setResolved(next);
        applyTheme(next);
      }
    };
    media.addEventListener('change', onChange);
    return () => media.removeEventListener('change', onChange);
  }, [theme]);

  return (
    <ThemeContext.Provider value={{ theme, resolved, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => React.useContext(ThemeContext);
